import { gql } from '@apollo/client';

export const UPDATE_EXPOSURE_TRIP = gql`
    mutation UpdateExposureTrip($id: Int!, $supportedOrganisationId: Int!, $name: String, $date: String, $location: String, $durationDays: Int, $description: String) {
        updateExposureTrip(id: $id, supportedOrganisationId: $supportedOrganisationId, name: $name, date: $date, location: $location, durationDays: $durationDays, description: $description) {
            id
            name
            date
            location
            durationDays
            description
        }
    }
`;
